import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Stack} from 'views/components';
import {Tab, TabContext, TabList, TabPanel} from 'views/components';

import {translate} from 'views/module';

import ClientHeader from './header/ClientHeader';
import Correspondances from './correspondances/Correspondances';
import ClientCalendar from './schedule/Schedule';
import CaregiverConnection from './caregiver_connection/CaregiverConnection';
import RelationshipList from './relationships/RelationshipList';
import Payment from './payment/Payment';
import CareviewSettings from './careview_settings/CareviewSettings';
import Careplan from './careplan/Careplan';
import Forms from './forms/Forms';

const ClientFeed = (props) => {
  const {
    feedTab,
    setFeedTab,
  } = props;

  const handleChange = (event, newValue) => {
    setFeedTab(newValue);
  };

  return (
    <Paper >
      <Stack>
        <ClientHeader
          {...props}
        />
        <TabContext
          value={feedTab}
        >
          <TabList
            onChange={handleChange}
            sx={{borderBottom: 1, borderColor: 'divider'}}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              label={translate('client.ClientDetail.Correspondance.Title')}
              value="CORRESPONDANCE"
            />
            <Tab
              label={translate('client.ClientDetail.Scheduling.Title')}
              value="SCHEDULING"
            />
            <Tab
              label={translate('client.ClientDetail.CaregiverConnections.Title')}
              value="CAREGIVER"
            />
            <Tab
              label={translate('client.ClientDetail.Relationships.Title')}
              value="RELATIONSHIP"
            />
            <Tab
              label={translate('client.ClientDetail.Payment.Title')}
              value="PAYMENT"
            />
            <Tab
              label={translate('client.ClientDetail.Careplan.Title')}
              value="CAREPLAN"
            />
            <Tab
              label={translate('client.ClientDetail.FormSettings.Title')}
              value="FORMS"
            />
            <Tab
              label={translate('client.ClientDetail.CareviewSettings.Title')}
              value="CAREVIEW_SETTINGS"
            />
          </TabList>
          <TabPanel
            value={'CORRESPONDANCE'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Correspondances
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'SCHEDULING'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <ClientCalendar
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'CAREGIVER'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <CaregiverConnection
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'RELATIONSHIP'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <RelationshipList
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'PAYMENT'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Payment
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'CAREVIEW_SETTINGS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <CareviewSettings
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'FORMS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Forms
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'CAREPLAN'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Careplan
              {...props}
            />
          </TabPanel>
        </TabContext>
      </Stack>
    </Paper>
  );
};
ClientFeed.propTypes = {
  clientRn: PropTypes.string.isRequired,
  clientData: PropTypes.object.isRequired,
  feedTab: PropTypes.string.isRequired,
  setFeedTab: PropTypes.func.isRequired,
};

export default React.memo(ClientFeed);
